import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const PlainAssetCardSkeleton = () => {
  return (
    <div
      className='plain-asset-card plain-asset-card-skeleton'
      data-testid='plain-asset-card-skeleton'
    >
      <div className='plain-asset-image'>
        <Skeleton height={200} width='100%' />
      </div>
      <div className='plain-asset-details'>
        <div className='plain-asset-title'>
          <Skeleton width={150} />
        </div>
        <div className='plain-asset-description-wrapper'>
          <Skeleton count={3} width='100%' />
        </div>
      </div>
    </div>
  );
};

export default PlainAssetCardSkeleton;
